import React from "react";
import styles from "../style.module.scss";
import VisaIcon from "../../../../../../../../../assets/svg/icons/cards/VisaIcon";
import MastercardIcon from "../../../../../../../../../assets/svg/icons/cards/MastercardIcon";
import DiscoverIcon from "../../../../../../../../../assets/svg/icons/cards/DiscoverIcon";
import AmexIcon from "../../../../../../../../../assets/svg/icons/cards/AmexIcon";

/**
 * Regular card icons group component
 * @returns {React.ReactElement} Regular card icons
 */
export const RegularCardIcons = () => (
  <>
    <div className={`${styles.cardIcon} ${styles.visa}`}>
      <VisaIcon />
    </div>
    <div className={`${styles.cardIcon} ${styles.mastercard}`}>
      <MastercardIcon />
    </div>
    <div className={`${styles.cardIcon} ${styles.discover}`}>
      <DiscoverIcon />
    </div>
  </>
);

/**
 * AMEX icon component
 * @returns {React.ReactElement} AMEX icon
 */
export const AmexCardIcon = () => (
  <div className={`${styles.cardIcon} ${styles.amex}`}>
    <AmexIcon />
  </div>
);
